<template>
  <div class="bg_content">
    <div class="chapter_container">
      <div class="top">
        <p class="title">章节资料</p>
        <div class="select">
          <div class="select_wrapper click_able"
               @click="actionShow = !actionShow;">
            <span v-if="moduleOption && moduleOption.length">{{moduleOption[chooseValue].name}}</span>
            <img src="/images/icon_up_down_triangle.png" />
          </div>
        </div>
      </div>
      <div class="content">
        <van-row class="content"
                 style="padding-top: 20px;">
          <happy-scroll hide-horizontal
                        resize
                        v-if="moduleList && moduleList.length">
            <van-col :style="{marginLeft: index % 2 === 1 && !$store.getters['global/activeIsPhone'] ? '20px' : '0'}"
                     @click="tapModule(item)"
                     v-for="(item, index) in moduleList"
                     :key="index"
                     class="quiz_panel click_able"
                     :span="!$store.getters['global/activeIsPhone'] ? 11 : 24"
                     :class="[item.active ? 'active' : '']">
              <div class="quiz">
                <p class="title">{{item.name}}</p>
                <div class="bottom">
                  <p class="limit_time"
                     :class="[!$store.getters['global/activeIsPhone'] ? '' : 'hanby_limit_time']">{{item.modplural}}</p>
                </div>
              </div>
            </van-col>
          </happy-scroll>
        </van-row>
      </div>
    </div>
    <van-action-sheet v-model="actionShow"
                      :actions="moduleOption"
                      @select="onSelect" />
  </div>
</template>
<script>
// @ is an alias to /src
import Vue from 'vue'
import course from '@/api/course/index'
import '@vant/touch-emulator'
import { ActionSheet, Row, Col } from 'vant'
Vue.use(ActionSheet)
  .use(Row)
  .use(Col)
export default {
  name: 'chapterMain',
  components: {},
  computed: {},
  data () {
    return {
      isLoading: false,
      actionShow: false,
      chooseValue: 0,
      moduleOption: [],
      moduleList: []
    }
  },
  methods: {
    onSelect (value, key) {
      this.chooseValue = key
      this.actionShow = false
      this.getModuleData()
    },
    getModuleData () {
      this.moduleList = this.moduleOption[this.chooseValue].value.modules
    },
    onLoad () {
      this.isLoading = false
    },
    tapModule (item) {
      console.log(item)
    },
    handleError () { },
    async ModuleData () {
      let result = await course.getCourseContent({
        params: { courseid: this.$store.state.course.courseId },
        loadingText: '正在获取课程模块信息',
        errorFn: this.handleError
      })
      if (result && result.length) {
        this.moduleOption = result.map((v, k) => {
          return {
            value: v,
            name: v.name
          }
        })
        this.getModuleData()
      }
    }
  },
  created () { },
  mounted () {
    this.ModuleData()
  }
}
</script>
<style lang="less" scoped>
.bg_content {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 48px;
  padding: 60px;
  position: relative;
  z-index: 9;
  margin: 50px 210px;
  .chapter_container {
    display: flex;
    height: 100%;
    flex-direction: column;
    .content {
      height: 100%;
    }
    .scroll_wrapper {
      overflow: hidden;
    }
    .scroll_content {
      overflow-y: scroll;
      width: calc(~"100% + 20px");
    }
    .clearPc {
      height: auto;
      overflow: hidden;
    }
    .top {
      display: flex;
      .title {
        font-size: 54px;
        font-weight: bold;
      }
      .select {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        .select_wrapper {
          width: 50%;
          padding: 14px 15px;
          border-radius: 6px;
          border: 1px solid rgba(221, 221, 221, 1);
          display: flex;
          align-items: center;
          span {
            flex: 1;
            color: #333333;
            font-size: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          img {
            margin-left: 10px;
            width: 16px;
            height: 20px;
          }
        }
      }
    }
    .quiz_panel {
      margin-bottom: 30px;
      height: 188px;
      padding: 30px;
      border-radius: 20px;
      border: 1px solid rgba(221, 221, 221, 1);
      .quiz {
        width: 100%;
        height: 100%;
        .title {
          color: #333333;
          font-size: 36px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .bottom {
          margin-top: 50px;
          display: flex;
          align-items: center;
          .limit_time {
            flex: 1;
            font-size: 24px;
            color: #6c6c6c;
          }
          .hanby_limit_time {
            flex: initial;
            width: 100%;
          }
          .hanby_limit_visible {
            margin: 10px 0 0 0;
          }
        }
      }
    }
    .active {
      border-color: #7cd2b0;
      .title {
        color: #37ab7e;
      }
    }
  }
}
</style>
